import React, { useState } from 'react';
import { createLead } from '../../api/leadApi';
import './CreateLead.css';  // Import the CSS file for styling

const CreateLead = () => {
    const [formData, setFormData] = useState({
        user: null,  // Assuming you will have a user selection or association mechanism
        leadType: 'auto',
        year: '',
        make: '',
        model: '',
        additionalDetails: '',
        distancePreference: 'any',
    });

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await createLead(formData);
            console.log(response);
        } catch (error) {
            console.error(error);
        }
    };

    return (
        <div className="form-container">
            <h2>Create Lead</h2>
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label htmlFor="leadType">Lead Type</label>
                    <select id="leadType" name="leadType" value={formData.leadType} onChange={handleChange}>
                        <option value="auto">Auto</option>
                        <option value="aircraft">Aircraft</option>
                        <option value="sneakers">Sneakers</option>
                        <option value="boat">Boat</option>
                    </select>
                </div>
                <div className="form-group">
                    <label htmlFor="year">Year</label>
                    <input type="number" id="year" name="year" value={formData.year} onChange={handleChange} placeholder="Year" />
                </div>
                <div className="form-group">
                    <label htmlFor="make">Make</label>
                    <input type="text" id="make" name="make" value={formData.make} onChange={handleChange} placeholder="Make" />
                </div>
                <div className="form-group">
                    <label htmlFor="model">Model</label>
                    <input type="text" id="model" name="model" value={formData.model} onChange={handleChange} placeholder="Model" />
                </div>
                <div className="form-group">
                    <label htmlFor="additionalDetails">Additional Details</label>
                    <textarea id="additionalDetails" name="additionalDetails" value={formData.additionalDetails} onChange={handleChange} placeholder="Additional Details"></textarea>
                </div>
                <div className="form-group">
                    <label htmlFor="distancePreference">Distance Preference</label>
                    <select id="distancePreference" name="distancePreference" value={formData.distancePreference} onChange={handleChange}>
                        <option value="25">25 Miles or Less</option>
                        <option value="50">50 Miles or Less</option>
                        <option value="100">100 Miles or Less</option>
                        <option value="250">250 Miles or Less</option>
                        <option value="any">Any Distance</option>
                    </select>
                </div>
                <button type="submit" className="submit-button">Create Lead</button>
            </form>
        </div>
    );
};

export default CreateLead;
